import { driverApi } from "./driver.api";

export const { useGetDriverQuery, useGetDriverQueueLeaveStatusQuery, useListDriversByCompanyInfiniteQuery, useSaveDriverMutation } = driverApi;
